// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lottery-box[data-v-5f699584]{position:absolute;top:50%;left:50.7%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
